import { NetFetch } from '../Net/NetFetch';
import { UnauthorizedError } from './Error/UnauthorizedError';
import { StatusCodes } from './Status/StatusCodes';
/**
 * Live AIS — current vessels in the buffer (joined with static
 * vessel metadata). The live-map page polls this every ~30 s.
 */
export class AisLive {
    static async getList(req) {
        var _a;
        const result = await NetFetch.postData('/json/ais/live/list', req !== null && req !== void 0 ? req : {});
        if (result && result.statusCode) {
            switch (result.statusCode) {
                case StatusCodes.OK:
                    return (_a = (result.list)) !== null && _a !== void 0 ? _a : [];
                case StatusCodes.UNAUTHORIZED:
                    throw new UnauthorizedError();
            }
        }
        return [];
    }
    /**
     * Chronological track for one MMSI from the live buffer. Defaults
     * to the last hour. Returns oldest → newest so the caller can feed
     * the coords straight into a polyline.
     */
    static async getTrack(mmsi, sinceSeconds) {
        var _a;
        const req = { mmsi };
        if (typeof sinceSeconds === 'number') {
            req.since_seconds = sinceSeconds;
        }
        const result = await NetFetch.postData('/json/ais/vessel/track', req);
        if (result && result.statusCode) {
            switch (result.statusCode) {
                case StatusCodes.OK:
                    return (_a = (result.points)) !== null && _a !== void 0 ? _a : [];
                case StatusCodes.UNAUTHORIZED:
                    throw new UnauthorizedError();
            }
        }
        return [];
    }
}
